<template>
    <el-carousel :interval="3000" height="800px" type="card">
            <el-carousel-item v-for="(item,index) in images" :key="item">

              <video class="fheight" width="100%" height="180px" v-if="getMediaType(item) == 2" :src="item"
                     controls="controls"></video>

              <img class="fheight" width="100%" height="180px" v-else :src="item"/>
            </el-carousel-item>
          </el-carousel>
</template>

<script>



export default {
  props: {
    images: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  mounted(){
    
  },
  methods: {
    getMediaType(name) {

      let type = name.substring(name.lastIndexOf(".") + 1);

      let imgType = ['bmp', 'jpg', 'png', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp', 'avif', 'apng'];

      if (imgType.some(e => e == type)) {
        return 1;
      }

      let videoType = ['mp4', 'mkv', 'avi', 'mov', 'wmv', '3gp', 'rm', 'rmvb']

      if (videoType.some(e => e == type)) {
        return 2
      }

      return 1;

    }
  }
};
</script>

<style>

.fheight {
  height: 900px;
}

</style>



// WEBPACK FOOTER //
// src/components/PhotoHourse.vue